module.exports = __webpack_public_path__ + "static/img/pic20.b7bc4fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic20.png
// module id = 2Bhu
// module chunks = 0